import React from 'react';

import Platform from '../../components/platform/Platform';

import './all-games.scss';


export default function AllGames() {


    return (
        <div className='all-games'>
            <h1>All Games</h1>
            <Platform />
        </div>
    );
};
